// All 77 provinces in Thailand (bilingual)
export const THAILAND_PROVINCES = [
  "กรุงเทพมหานคร (Bangkok)",
  "กระบี่ (Krabi)",
  "กาญจนบุรี (Kanchanaburi)",
  "กาฬสินธุ์ (Kalasin)",
  "กำแพงเพชร (Kamphaeng Phet)",
  "ขอนแก่น (Khon Kaen)",
  "จันทบุรี (Chanthaburi)",
  "ฉะเชิงเทรา (Chachoengsao)",
  "ชลบุรี (Chonburi)",
  "ชัยนาท (Chai Nat)",
  "ชัยภูมิ (Chaiyaphum)",
  "ชุมพร (Chumphon)",
  "เชียงราย (Chiang Rai)",
  "เชียงใหม่ (Chiang Mai)",
  "ตรัง (Trang)",
  "ตราด (Trat)",
  "ตาก (Tak)",
  "นครนายก (Nakhon Nayok)",
  "นครปฐม (Nakhon Pathom)",
  "นครพนม (Nakhon Phanom)",
  "นครราชสีมา (Nakhon Ratchasima)",
  "นครศรีธรรมราช (Nakhon Si Thammarat)",
  "นครสวรรค์ (Nakhon Sawan)",
  "นนทบุรี (Nonthaburi)",
  "นราธิวาส (Narathiwat)",
  "น่าน (Nan)",
  "บึงกาฬ (Bueng Kan)",
  "บุรีรัมย์ (Buriram)",
  "ปทุมธานี (Pathum Thani)",
  "ประจวบคีรีขันธ์ (Prachuap Khiri Khan)",
  "ปราจีนบุรี (Prachinburi)",
  "ปัตตานี (Pattani)",
  "พระนครศรีอยุธยา (Phra Nakhon Si Ayutthaya)",
  "พะเยา (Phayao)",
  "พังงา (Phang Nga)",
  "พัทลุง (Phatthalung)",
  "พิจิตร (Phichit)",
  "พิษณุโลก (Phitsanulok)",
  "เพชรบุรี (Phetchaburi)",
  "เพชรบูรณ์ (Phetchabun)",
  "แพร่ (Phrae)",
  "ภูเก็ต (Phuket)",
  "มหาสารคาม (Maha Sarakham)",
  "มุกดาหาร (Mukdahan)",
  "แม่ฮ่องสอน (Mae Hong Son)",
  "ยโสธร (Yasothon)",
  "ยะลา (Yala)",
  "ร้อยเอ็ด (Roi Et)",
  "ระนอง (Ranong)",
  "ระยอง (Rayong)",
  "ราชบุรี (Ratchaburi)",
  "ลพบุรี (Lopburi)",
  "ลำปาง (Lampang)",
  "ลำพูน (Lamphun)",
  "เลย (Loei)",
  "ศรีสะเกษ (Sisaket)",
  "สกลนคร (Sakon Nakhon)",
  "สงขลา (Songkhla)",
  "สตูล (Satun)",
  "สมุทรปราการ (Samut Prakan)",
  "สมุทรสงคราม (Samut Songkhram)",
  "สมุทรสาคร (Samut Sakhon)",
  "สระแก้ว (Sa Kaeo)",
  "สระบุรี (Saraburi)",
  "สิงห์บุรี (Sing Buri)",
  "สุโขทัย (Sukhothai)",
  "สุพรรณบุรี (Suphan Buri)",
  "สุราษฎร์ธานี (Surat Thani)",
  "สุรินทร์ (Surin)",
  "หนองคาย (Nong Khai)",
  "หนองบัวลำภู (Nong Bua Lam Phu)",
  "อ่างทอง (Ang Thong)",
  "อุดรธานี (Udon Thani)",
  "อุทัยธานี (Uthai Thani)",
  "อุตรดิตถ์ (Uttaradit)",
  "อุบลราชธานี (Ubon Ratchathani)",
  "อำนาจเจริญ (Amnat Charoen)",
] as const;

// 50 districts of Bangkok (เขต - bilingual)
export const BANGKOK_DISTRICTS = [
  "พระนคร (Phra Nakhon)",
  "ดุสิต (Dusit)",
  "หนองจอก (Nong Chok)",
  "บางรัก (Bang Rak)",
  "บางเขน (Bang Khen)",
  "บางกะปิ (Bang Kapi)",
  "ปทุมวัน (Pathum Wan)",
  "ป้อมปราบศัตรูพ่าย (Pom Prap Sattru Phai)",
  "พระโขนง (Phra Khanong)",
  "มีนบุรี (Min Buri)",
  "ลาดกระบัง (Lat Krabang)",
  "ยานนาวา (Yan Nawa)",
  "สัมพันธวงศ์ (Samphanthawong)",
  "พญาไท (Phaya Thai)",
  "ธนบุรี (Thon Buri)",
  "บางกอกใหญ่ (Bangkok Yai)",
  "ห้วยขวาง (Huai Khwang)",
  "คลองสาน (Khlong San)",
  "ตลิ่งชัน (Taling Chan)",
  "บางกอกน้อย (Bangkok Noi)",
  "บางขุนเทียน (Bang Khun Thian)",
  "ภาษีเจริญ (Phasi Charoen)",
  "หนองแขม (Nong Khaem)",
  "ราษฎร์บูรณะ (Rat Burana)",
  "บางพลัด (Bang Phlat)",
  "ดินแดง (Din Daeng)",
  "บึงกุ่ม (Bueng Kum)",
  "สาทร (Sathon)",
  "บางซื่อ (Bang Sue)",
  "จตุจักร (Chatuchak)",
  "บางคอแหลม (Bang Kho Laem)",
  "ประเวศ (Prawet)",
  "คลองเตย (Khlong Toei)",
  "สวนหลวง (Suan Luang)",
  "จอมทอง (Chom Thong)",
  "ดอนเมือง (Don Mueang)",
  "ราชเทวี (Ratchathewi)",
  "ลาดพร้าว (Lat Phrao)",
  "วัฒนา (Watthana)",
  "บางแค (Bang Khae)",
  "หลักสี่ (Lak Si)",
  "สายไหม (Sai Mai)",
  "คันนายาว (Khan Na Yao)",
  "สะพานสูง (Saphan Sung)",
  "วังทองหลาง (Wang Thonglang)",
  "คลองสามวา (Khlong Sam Wa)",
  "บางนา (Bang Na)",
  "ทวีวัฒนา (Thawi Watthana)",
  "ทุ่งครุ (Thung Khru)",
  "บางบอน (Bang Bon)",
] as const;

// Bangkok vicinity provinces (ปริมณฑล)
export const BANGKOK_VICINITY_PROVINCES = [
  "นนทบุรี (Nonthaburi)",
  "ปทุมธานี (Pathum Thani)",
  "สมุทรปราการ (Samut Prakan)",
  "สมุทรสาคร (Samut Sakhon)",
  "นครปฐม (Nakhon Pathom)",
] as const;

// Extract Thai name from bilingual string (e.g., "กรุงเทพมหานคร (Bangkok)" -> "กรุงเทพมหานคร")
export const extractThaiName = (bilingualName: string): string => {
  const match = bilingualName.match(/^(.+?)\s*\(/);
  return match ? match[1].trim() : bilingualName;
};

// Helper function to check if a province is Bangkok
export const isBangkok = (province: string): boolean => {
  const thaiName = extractThaiName(province);
  return thaiName === "กรุงเทพมหานคร";
};

// Helper function to check if a province is in Bangkok vicinity
export const isBangkokVicinity = (province: string): boolean => {
  const thaiName = extractThaiName(province);
  return BANGKOK_VICINITY_PROVINCES.some((p) => extractThaiName(p) === thaiName);
};

// Format location for display
export const formatLocation = (locationData: { province: string; district?: string }): string => {
  if (locationData.district) {
    return `${locationData.province} - ${locationData.district}`;
  }
  return locationData.province;
};
